export default {
  path: '/material_types',
  name: 'material_types',
  component: () => import('../components/materialtype/Layout'),
  redirect: { name: 'MaterialTypeList' },
  meta: {
    breadcrumb: 'profile.material.types',
  },
  children: [
    {
      name: 'MaterialTypeList',
      path: '',
      component: () => import('../views/materialtype/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MaterialTypeCreate',
      path: 'new',
      component: () => import('../views/materialtype/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MaterialTypeUpdate',
      path: ':id/edit',
      component: () => import('../views/materialtype/Update'),
      meta: {
        breadcrumb: 'profile.material.type',
      },
    },
    {
      name: 'MaterialTypeShow',
      path: ':id',
      component: () => import('../views/materialtype/Show'),
      meta: {
        breadcrumb: 'profile.material.type',
      },
    }
  ]
};
